import { render } from "./EpisodeDetailView.vue?vue&type=template&id=5dc84c60&scoped=true"
import script from "./EpisodeDetailView.vue?vue&type=script&lang=js"
export * from "./EpisodeDetailView.vue?vue&type=script&lang=js"

import "./EpisodeDetailView.vue?vue&type=style&index=0&id=5dc84c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc84c60"]])

export default __exports__